<template>
  <div>
    <div class="nodata text-cent" v-if="finished && datas == ''">
      <P class="imgbox">
        <img src="/static/images/nodataimg2.png"/>
      </P>
      <p class="text">还没有相关订单~</p>
    </div>
    <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="0">
      <van-cell-group v-for="(items,index) in datas" :key="items.id">
        <div class="van-cell">
          <div class="van-cell__title">
            <span>订单编号：{{ items.order_sn }}</span>
            <span class="float-right theme-col">{{ items.status_info.desc }}</span>
          </div>
        </div>
        <van-card class="goodsonelist" v-for="item in items.goods" :key="item.id">
          <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/goodslist/goods',query:{id:item.goods_id}}">
            <img :src="item.product_img" onerror="src='/static/errorimg1.png'">
          </router-link>
          <div slot="title" class="ellipseal van-card-title">
            <div class="ellipseal">
              {{ item.goods_name }}
            </div>
            <p class="tagbox">
              <!--<span class="theme-bg theme-bg radius" v-if="item.is_new == 1">新品</span>-->
              <!--<span class="theme-bg theme-bg  radius" v-if="item.is_hot == 1">热销</span>-->
              <!--<span class="theme-bg theme-bg  radius" v-if="item.is_rob == 1">限时</span>-->
              <span plain class="theme-col theme-bg jd  radius" v-if="item.dummy == 3">京东</span>
            </p>
          </div>
          <div slot="desc" class="van-card-desc theme-col"><span>{{ item.goods_point }}</span></div>
          <div slot="footer">
            <span class="theme-col">x{{ item.goods_nums }}</span>
          </div>
        </van-card>
        <div class="van-cell">
          <div class="van-cell__title text-right">
            <div>合计：{{ items.subtotal }}，共{{ items.goods.length }}件商品</div>
            <div>
              <!--<router-link to="/">
                <van-button size="small" v-if="items.botton_info.pay_show==1">去评价</van-button>
              </router-link>-->
              <van-button size="small" v-if="items.botton_info.pay_show==1" @click="payOrder(items.order_sn)">去支付</van-button>
              <router-link :to="{name:'Order',query:{id:items.id}}">
                <van-button size="small">查看详情</van-button>
              </router-link>
              <!-- <van-button size="small" v-if="items.botton_info.delete_show == 1" @click="delOrder(items.id,index)">删除订单</van-button> -->
              <van-button size="small" v-if="items.botton_info.cancel_show==1" @click="cancelOrder(items.id,index)">取消订单</van-button>
              <van-button size="small" v-if="items.botton_info.confirm_show==1" @click="confirmOrder(items.id,index)" class="theme-bg theme-bd">确认收货</van-button>
              <!--<router-link to="/">
                <van-button size="small" v-if="items.botton_info.logistics_show==1">查看物流</van-button>
              </router-link>-->
            </div>
          </div>
        </div>
      </van-cell-group>
      <div v-if="!loading && finished && datas != ''" class="nomore"><span>已经到底了</span></div>
    </van-list>
  </div>
</template>
<script>
  export default {
    name: "orderlist",
    data () {
      return {
        datas:[],
        page:0,
        finished:false,
        loading:false,
      }
    },
    computed: {
      type:function () {
        if(this.$route.query.type == 1){
          return 1
        }else if(this.$route.query.type == 2){
          return 2
        }else if(this.$route.query.type == 3){
          return 3
        }else if(this.$route.query.type == 4){
          return 4
        }else {
          return 0
        }
      }
    },
    methods: {
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        setTimeout(() => {
          this.page++
          this.$api.post('WebApi/JifenOrder/Order/index', {token:isUser,type:this.type,p:this.page}, res => {
            if(res.data.errCode == '0000'){
              if(res.data.data.datas == null){
                _this.finished = true;
                _this.loading = false;
              }else{
                for (let i = 0; i < res.data.data.datas.length; i++) {
                  _this.datas.push(res.data.data.datas[i]);
                }
                _this.loading = false;
              }
            }else{
              this.$toast.alert(res.data.desc);
              _this.loading = false;
            }
          })
        },50)
      },
      //去支付
      payOrder: function (id) {
        var isUser = localStorage.getItem("BLHuser")
        var root = process.env.API_ROOT
        window.location.href=root+"/WebApi/JifenOrder/OrderPay/pay?"+"sn="+id+"&token="+isUser+"&payurl="+window.location.host+"/ordersucceed"
      },
      //删除订单
      delOrder: function (id,index) {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/delOrder', {token:isUser,id:id}, res => {
            if(res.data.errCode == '0000'){
              this.$toast(res.data.desc)
              this.datas.splice(index, 1)
            }else if(res.data.errCode == '1002'){
              this.$dialog.confirm({
                title: '提示',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({path: '/login'})
              }).catch(() => {
                // on cancel
              });
            }else{
              this.$toast(res.data.desc)
            }
        })
      },
      //取消订单
      cancelOrder: function (id,index) {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/cancelOrder', {token:isUser,id:id}, res => {
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc);
            this.datas[index].botton_info.pay_show = 0
            this.datas[index].botton_info.cancel_show = 0
            this.datas[index].botton_info.confirm_show = 0
            this.datas[index].botton_info.delOrder = 1
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title: '提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path: '/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc);
          }
        })
      },
      //确认收货
      confirmOrder: function (id,index){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/confirmReceipt', {token:isUser,id:id}, res => {
          if(res.data.errCode == '0000'){
//            this.$toast(res.data.desc)
            this.$router.push({ path: '/user/myorder/finishorder?type=4' })
            this.datas[index].botton_info.pay_show = 0
            this.datas[index].botton_info.cancel_show = 0
            this.datas[index].botton_info.confirm_show = 0
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title: '提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path: '/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc)
          }
        })
      }
    },
    mounted () {
//        this.getDatas();
    },
  }
</script>
<style scoped>
  .radius {
    padding: 0 5px 1px!important;
    -webkit-border-radius:10px 0;
    -moz-border-radius:10px 0;
    border-radius:10px 0 ;

  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist.vue